<template>
  <div id="Employee" class="print-content">
    <div>hi</div>
     <section
      dir="rtl"
      class="pdf-content font-modify m-5 text-dark"
      slot="pdf-content"
    >
      <div dir="rtl" class="container mt-3">

        <table class="mt-1 print-table">
          <tr class="table-sections" style="background-color: yellow ;font-size: 40px;">
            <td colspan="8" class="text-center" 
            style="font-weight: 800;">
              رواتب موظفي مستشفى الوزيريه الاهلي لشهر {{ getArabicMonthName(1) }} سنه 2024 
            </td>

            <tr class="table-sections" style="background-color: yellow">
            <th scope="col" style="font-size: 20px;font-weight: 600;">ت</th>
            <th scope="col" style="font-size: 25px;font-weight: 600;">الاسم الثلاثي</th>
            <th scope="col" style="font-size: 25px;font-weight: 600;">العنوان الوظيفي</th>
            <th scope="col" style="font-size: 25px;font-weight: 600;">الاسمي</th>
            <th scope="col" style="font-size: 25px;font-weight: 600;">الاضافي</th>
            <th scope="col" style="font-size: 25px;font-weight: 600;">الاستقطاع</th>
            <th scope="col" style="font-size: 25px;font-weight: 600;">الصافي</th>
            <th scope="col"  style="font-size: 25px; font-weight: 600;;width: 300px">الملاحظات</th>
            </tr>
          </tr>
          <tbody>
            <tr
              class="table-sections"
              v-for="(employee, index) in data"
              :key="index"
              style="font-size: 30px;"
            >
              <th class="table-sections"  style="font-size: 25px;"scope="row">{{ index + 1 }}</th>
              <td class="table-sections" style="font-size: 25px; font-weight: 600;">{{ employee.full_name }}</td>
              <td class="table-sections"style="font-size: 25px; font-weight: 600;">{{ employee.job_title || "" }}</td>
              <td class="table-sections" style="font-size: 25px; font-weight: 600;">{{ employee.base_salary }}</td>
              <td class="table-sections"style="font-size: 25px; font-weight: 600;">{{ employee.salary? employee.salary.additional_salary:'' }}</td>
              <td class="table-sections"style="font-size: 25px; font-weight: 600;">{{ employee.salary? employee.salary.deduction_salary:'' }}</td>
              <td class="table-sections"style="font-size: 25px; font-weight: 600;">{{ employee.salary? employee.salary.total_salary:'' }}</td>
              <td class="table-sections" style="font-size: 25px;font-weight: 600;"></td>
            </tr>
          </tbody> 
        </table>
        <div class="row justify-content-center mt-3">
          <div class="col-auto">
            <span style="font-size: 34px; font-weight: 700;">المحاسب موفق عبدالكريم جاسم</span>
          </div>
          <div class="col-auto">
            <span class="mx-3" style="font-size: 34px; font-weight: 700;">مسؤؤول الحسابات مها علي عبدالرزاق</span>
          </div>
        </div>
        <div class="row justify-content-center mt-3">
          <div class="col-auto">
            <span style="font-size: 40px; font-weight: 700;">مدير المستشفى الدكتورة ابتهاج سيف الدين ثابت الالوسي</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: String,
      required: true,
    },
  },  mounted() {
console.log('jj',this.data);
  },
  methods:{
     getArabicMonthName(monthNumber) {
      const arabicMonths = [
    'يناير', // 
    'فبراير', // S
    'مارس', //
    'ابريل', // R
    'مايو', // Jum
    'يونيو', // J
    'يوليو', // 
    'أغسطس', // 
    'سبتمبر', // 
    'أكتوبر', // 
    'نوفمبر', // 
    'ديسمبر' // 
  ];

  const currentMonth = new Date().getMonth(); // Month is 0-indexed (0 = January, 11 = December)
  return arabicMonths[currentMonth];
},
  }
};
</script>

<style scoped>
.print-content {
  display: none;
}

/* Show the print content when printing */
@media print {
  .print-content {
    display: block;
  }

}
.mb-md-0 {
  margin-top: 8px;
}

.print-table {
  width: 100%;
  border: 1px solid;
  font-size: 11px;
}




.table-sections {
  border: 1px solid;
  text-align:start;
  
 
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}



.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

.th{
  font-size: 300px;
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>
<!--  -->
